var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"is-small",attrs:{"type":_vm.buttonType,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.buttonLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }